module.exports = __webpack_public_path__ + "img/loghi.aa420f70.png";